export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || 'http://localhost:7071/api';

export const MOCK_AUTH_ENABLED =
  import.meta.env.VITE_MOCK_AUTH === 'true';

/** When false, the portal skips the login redirect — pages render without auth. */
export const AUTH_GATE_ENABLED =
  import.meta.env.VITE_AUTH_GATE !== 'false';

export const MARKETING_URL =
  import.meta.env.VITE_MARKETING_URL || 'https://seedgovernance.com';

// ── Entra External ID (CIAM) configuration ─────────────────────────────

export const ENTRA_CONFIG = {
  tenantSubdomain: import.meta.env.VITE_ENTRA_TENANT_SUBDOMAIN || 'seedgovlogin',
  clientId: import.meta.env.VITE_ENTRA_CLIENT_ID || '59899ebe-b16c-491f-9d7f-d1720940dd14',
} as const;

export const ENTRA_AUTHORITY = `https://${ENTRA_CONFIG.tenantSubdomain}.ciamlogin.com/`;

export const ENTRA_SCOPES = [
  `openid`,
  `profile`,
  `email`,
  `offline_access`,
];
